import type { ReactNode } from "react";

export type LgTagProps = {
  /** 強調だけ黄の地に墨の縁 (どちらのテーマでも)。1 画面に多用しない */
  emphasis?: boolean;
  /** 「次はここ」の札。hp は墨の地、classic は黄の地 (注目は classic でも黄)。1 画面に 1 つ */
  next?: boolean;
  className?: string;
  children: ReactNode;
};

/** 種類の札。薄い砂色の地に濃い灰の字 (10/19 代表「黒のタグはやめたい」)。色は tokens.css の --lg-tag-* が決める */
export function LgTag({ emphasis = false, next = false, className, children }: LgTagProps) {
  return <span className={`lg-tag${emphasis ? " lg-tag--mark" : ""}${next ? " lg-tag--next" : ""}${className ? ` ${className}` : ""}`}>{children}</span>;
}

export type LgBadgeProps = {
  /** brass は注記 (BETA など)、ink は強めの区別 */
  tone?: "brass" | "ink";
  className?: string;
  children: ReactNode;
};

/** 属性や注記の縁取りの印。タグより静かで、地は付けない */
export function LgBadge({ tone = "brass", className, children }: LgBadgeProps) {
  return <span className={`lg-badge lg-badge--${tone}${className ? ` ${className}` : ""}`}>{children}</span>;
}
